<template>
  <div class="container">
    <div 
      v-for="(item, index) in filteredList" 
      :key="index" 
      class="title-item" 
      @click="navigateToGradeNextPageChapter(item, index)"
    >
      {{ item.title }}
    </div>
  </div>
</template>

<script setup>
import gradeListFromJson  from './data/SubjectNextPageGrade.json'//这个是导入数据

import { ref ,computed,watch} from 'vue'

import { useRouter, useRoute} from 'vue-router'//引入导航行路由。
const router = useRouter()//调用useRouter()函数。
const route = useRoute() // 用于获取路由参数
// 接收上级传递的name参数（默认一年级）
const currentname = ref(route.query.name )
// 监听路由参数变化，更新 currentname
watch(
  () => route.query.name, // 监听路由中的 name 参数
  (newName) => {
    currentname.value = newName // 同步更新 currentname
  }
)
// 关键：用 computed 包裹，依赖 currentname.value，自动响应变化
const targetData = computed(() => {
  return gradeListFromJson[currentname.value] || []
})
console.log(targetData)
// filteredList 直接使用计算属性（如果不需要额外处理，可直接用 targetData）
const filteredList = computed(() => targetData.value)




// 导航函数
const navigateToGradeNextPageChapter = (item) => {
  
  // 方式2: 使用Vue Router（如果在H5环境）
  //router.push(item.navigatetopageurl)
  router.push({
          path: '/to-pagechapter',
          query: { name: item.name } //id 动态使用当前项的 title
        })
  
}
</script>

<style scoped>
.container {
  padding: 20rpx;
}

.title-item {
  width: 100%;           /* 宽度充满父容器 */
    box-sizing: border-box; /* 防止padding撑大宽度 */
    padding: 15px;         /* 原30rpx转换为15px（rpx通常1rpx≈0.5px） */
    margin-bottom: 10px;   /* 原20rpx转换为10px */
    background-color: #f5f5f5;
    border-radius: 4px;    /* 原8rpx转换为4px */
    font-size: 16px;       /* 原32rpx转换为16px */
    color: #333;
    border: none;          /* 移除默认边框（如果用于按钮） */
    text-align: left;      /* 文字左对齐 */
    cursor: pointer;       /* 鼠标悬停显示手型 */
    transition: background-color 0.2s ease; /* 平滑过渡效果 */
}

.title-item:active {
  background-color: #e5e5e5; /* 点击反馈效果 */
}


/* 电脑端专属：控制轮播图大小（屏幕≥1024px时生效） */
@media (min-width: 1024px) {
  /* 限制中间显示区宽度为手机竖屏常见宽度（如375px，可修改） */
  .container {
    max-width: 500px !important; /* 中间显示区宽度（手机常见宽度） */
    margin: 20px auto !important; /* 左右自动留白，居中显示 */
  }
}
</style>